import React, { useState, type ComponentType } from 'react'
import {
  Box,
  Button,
  ChakraProvider,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  useColorModeValue,
  Alert,
  AlertIcon,
  Flex,
  Icon,
  Text
} from '@chakra-ui/react'
import { RiShieldKeyholeLine } from 'react-icons/ri'
import config from '../config/config'
import AdminLayout from '../components/admin/AdminLayout'

const SESSION_STORAGE_KEY = 'isAdminAuthenticated'

const withAdminAuth = <P extends object>(WrappedComponent: ComponentType<P>): React.FC<P> => {
  const AuthenticatedComponent: React.FC<P> = (props) => {
    const [isAuthenticated, setIsAuthenticated] = useState(
      sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true'
    )
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handleLogin = (): void => {
      if (password === config.ADMIN_PASSWORD) {
        sessionStorage.setItem(SESSION_STORAGE_KEY, 'true')
        setIsAuthenticated(true)
        setError('')
      } else {
        setError('Contrasinal incorrecta.')
      }
    }

    if (!isAuthenticated) {
      return (
        <ChakraProvider>
          <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}
          >
            <Container maxW={'lg'}>
              <Stack spacing={8} mx={'auto'} py={12} px={6}>
                <Stack align={'center'} textAlign="center">
                  <Icon as={RiShieldKeyholeLine} boxSize={12} color="purple.500" mb={4}/>
                  <Heading fontSize={'2xl'}>Acceso á Zona de Administración</Heading>
                  <Text fontSize={'lg'} color={'gray.600'}>
                    Introduce a contrasinal para continuar
                  </Text>
                </Stack>
                <Box
                  rounded={'lg'}
                  bg={useColorModeValue('white', 'gray.700')}
                  boxShadow={'lg'}
                  p={8}
                >
                  <Stack spacing={4}>
                    <FormControl id="password">
                      <FormLabel>Contrasinal</FormLabel>
                      <Input
                        type="password"
                        value={password}
                        onChange={(e) => { setPassword(e.target.value) }}
                        onKeyPress={(e) => { if (e.key === 'Enter') handleLogin() }}
                      />
                    </FormControl>
                    <Stack spacing={6}>
                      {error !== '' && (
                        <Alert status="error" borderRadius="md">
                          <AlertIcon />
                          {error}
                        </Alert>
                      )}
                      <Button
                        colorScheme="purple"
                        onClick={handleLogin}
                      >
                        Entrar
                      </Button>
                    </Stack>
                  </Stack>
                </Box>
              </Stack>
            </Container>
          </Flex>
        </ChakraProvider>
      )
    }

    return (
      <ChakraProvider>
        <AdminLayout>
          <WrappedComponent {...props} />
        </AdminLayout>
      </ChakraProvider>
    )
  }

  return AuthenticatedComponent
}

export default withAdminAuth
